import React from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import {
  FormControl,
  InputLabel,
  FormHelperText,
  withStyles,
} from '@material-ui/core';
// import { Field } from 'redux-form';
import styles from './styles';

const SelectField = props => {
  const {
    id,
    classes,
    input,
    label,
    name,
    meta: { error, touched, invalid },
    children,
    ...custom
  } = props;
  return (
    <FormControl className={classes.selectRoot}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        native
        {...input}
        {...custom}
        inputProps={{
          name: label,
          id,
        }}
        error={touched && invalid}
      >
        {children}
      </Select>
      {touched && error && (
        <FormHelperText id={`${id}-helper-text`} className={classes.errorText}>
          {'Required'}
        </FormHelperText>
      )}
    </FormControl>
  );
};

SelectField.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.object,
  children: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }).isRequired,
};

export default withStyles(styles)(SelectField);
